module.exports = function() {
  return new Worker(__webpack_public_path__ + "9078930f25f30ca2359d.worker.js");
};